import { createAuthClient } from "better-auth/react";
import { emailOTPClient } from "better-auth/client/plugins";

const betterAuthClient = createAuthClient({
	basePath: "/",
	baseURL: import.meta.env.VITE_AUTH_API_URL,
	plugins: [emailOTPClient()],
	fetchOptions: {
		credentials: "include",
	},
});

export default betterAuthClient;
